<button class="ace-btn btn-sm btn-primary float-end" [hidden]="!editState.editMode" (click)="addBill()">
    <i class="fa fa-plus"></i> Add Bill
</button>
@if (viewModel.model.length === 0) {
    <div class="text-center" style="margin-top: 30px;">
        @if (currentYear) {
            <div class="lead">
                There are presently no tax bills for {{ currentYear.annualYear1 }}
            </div>
        }
        @if (!currentYear) {
            <div class="lead">
                There are presently no tax bills for this year.
            </div>
        }
        @if (editState.hasWritePermission) {
            <button class="ace-btn btn-primary" (click)="addBill()">New Bill</button>
        }
    </div>
}
@if (viewModel.model && viewModel.model.length > 0) {
    <tabset justify="start">
        @for (tab of viewModel.model; track tab; let i = $index) {
            <tab (selectTab)="switchTabs(viewModel, i)"
                 [disabled]="tab.disabled"
                 [active]="i === viewModel.currentTabIndex">
                <ng-template tabHeading>
                    <i class="fa {{tab.icon}}"
                       style="margin-right: 5px;"></i><span>{{ tab.title || tab.collector.abbr || tab.collector.name }} </span>
                </ng-template>
                <div style="display: flex; justify-content: space-between; position: relative;">
                    @if (!tab.refund) {
                        <bills [editState]="editState"
                               [viewModel]="getBillVM(tab)"
                               [showExtraFields]="tab.showExtraFields"
                               [gridNavigationHandler]="gridNavigationHandler"
                               [taxesViewModel]="viewModel"
                               [stateId]="tab.collector.stateID"
                               [siteId]="siteId"
                               [collector]="tab.collector"
                               (AnnualDetailsSaveAllowedChanged)="annualDetailsSaveAllowedChanged($event)"
                               (saveBillCluster)="saveBillCluster($event)">
                        </bills>
                    }
                    @if (tab.refund) {
                        <refund [editState]="editState"
                                [viewModel]="getRefundVM(tab)"
                                [taxesViewModel]="viewModel"
                                (refundDeleted)="reloadVM()">
                        </refund>
                    }
                    @if (tab.isAccrualsAvailable && !tab.allPaymentsExcludedFromAccrual) {
                        <a
                            (click)="launchAccrualDetailModal(tab)" class="pointer"
                            style="position: absolute; top: 5px;">Accrual
                            Detail</a>
                    }
                </div>
            </tab>
        }
    </tabset>
}

@if (isAddBillModalShown) {
    <div [config]="{ show: true }" (onHidden)="onHidden()"
         bsModal #addBillModal="bs-modal" class="modal fade"
         tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <ws-modal-wrapper headerLabel="Add One-time Bill or Refund"
                                  acceptLabel="Add"
                                  [disableSave]="waitingOnServer"
                                  (save)="saveBillOrRefund()"
                                  (cancel)="cancelAddBillOrRefund()">
                    <div style="text-align: center;">
                        <div class="radio" style="display: inline-block;">
                            <label>
                                <input type="radio" [(ngModel)]="billOrRefund.type" value="bill">
                                One Time Bill
                            </label>
                        </div>
                        <div class="radio" style="display: inline-block; margin-left: 15px;">
                            <label>
                                <input type="radio" [(ngModel)]="billOrRefund.type" value="refund">
                                Refund
                            </label>
                        </div>
                    </div>
                    <div style="margin-top: 15px;">
                        @if (hasCompanyCollectors) {
                            <div style="text-align:center;">
                                <div>
                                    <input type="radio" id="collectorTypeChoiceState" name="collectorTypeChoice"
                                           [value]="true" [(ngModel)]="isStateCollectorsShown"
                                           (change)="getCollectorList()" [disabled]="!parcelCollectors.length">
                                    <label for="collectorTypeChoiceState" style="margin-right: 24px;">Governmental
                                        Collectors</label>
                                    <input type="radio" id="collectorTypeChoiceCompany" name="collectorTypeChoice"
                                           [value]="false" [(ngModel)]="isStateCollectorsShown"
                                           (change)="getCollectorList()">
                                    <label for="collectorTypeChoiceCompany">Company Collectors</label>
                                </div>
                            </div>
                        }
                        <label>Collector:</label>
                        @if (isStateCollectorsShown) {
                            <select class="form-select form-select-sm" [(ngModel)]="billOrRefund.collectorID">
                                @for (collector of parcelCollectors; track collector) {
                                    <option [ngValue]="collector.collectorID">{{ collector.collector.abbr }}</option>
                                }
                            </select>
                        }
                        @if (!isStateCollectorsShown) {
                            <select class="form-select form-select-sm" [(ngModel)]="billOrRefund.collectorID">
                                @for (collector of companyCollectors; track collector) {
                                    <option [ngValue]="collector.collectorID">{{ collector.abbr }}</option>
                                }
                            </select>
                        }
                    </div>
                </ws-modal-wrapper>
            </div>
        </div>
    </div>
}
